import { userInfoSync } from 'hub-http/userInfo';
import enviro from 'enviro';
import Raven from 'raven-js';

export const hasScope = (scopeName: string) => {
  try {
    const userInfo = userInfoSync();
    const { scopes } = userInfo?.user || { scopes: [] };

    return scopes.includes(scopeName);
  } catch (err: unknown) {
    if (enviro.isQa()) {
      console.error(err);
    }
    Raven.captureException(err as Error, {
      extra: {
        message: 'Error getting user info from `userInfoSync`',
      },
    });
  }

  return false;
};
